import { Checkbox, Collapse } from "antd";
import styled from "styled-components";

const collapseBorderColors = {
    p: "#f1691b",
    r: "#1677FF",
    offline: "#d500f9",
    closed: "#49AA19",
    opened: "transparent",
};

export const StyledCACollapse = styled(Collapse)<{ borderColor: string }>`
    width: 100%;
    border: none;
    border-radius: 0;

    .ant-collapse-content-box {
        padding: 8px;
    }

    .ant-collapse-item {
        background-color: transparent !important;
    }

    .ant-collapse-item-active {
        .ant-collapse-header {
            border-radius: 0 10px 0 0 !important;
        }
    }

    border-left: 2px solid ${(props) => collapseBorderColors[props.borderColor]};
`;

export const StyledCACheckbox = styled(Checkbox)<{ isActive?: boolean }>`
    margin-top: 16px;
    margin-right: 12px;
    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #52c41a !important;
        border-color: #52c41a !important;
    }

    .ant-checkbox-checked::after {
        border-color: #52c41a !important;
    }

    .ant-checkbox-inner {
        width: 18px;
        height: 18px;
        border: 2px solid ${(props) => props.theme.checkboxBorder};

        background-color: ${(props) =>
            props.isActive
                ? props.theme.secondaryBackgroundColor
                : props.theme.inactiveTabColor};
        opacity: ${(props) => (props.isActive ? 1 : 0.2)};
    }

    .ant-checkbox-checked .ant-checkbox-inner::after {
        border: 2px solid #fff;
        border-top: none;
        border-left: none;
        transform: rotate(45deg) scale(1) translate(-50%, -50%);
    }
`;
